










































  import {
    Prop,
    Vue,
    Component
  } from "@/shared/vuepack";
  import OfferSummary from "@/employee/components/ebto/OfferSummary.vue";

  @Component({
  components: {
    OfferSummary
  }
})
  export default class StayOfferSummary extends Vue {

    @Prop()
    isFeeWaived: boolean;

    @Prop()
    hasIncentiveBonus: number;

    get hasPricingOffer (): boolean {
    return (this.hasIncentiveBonus > 0 || this.isFeeWaived);
  }

  }
